import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { trackScreenView } from './index';
import { resolveScreenName } from './screenMap';
import type { TrackContextPayload, TrackScreenName } from './types';

export function useTrackScreenView(
  override?: TrackScreenName,
  payload?: TrackContextPayload
): void {
  const location = useLocation();
  useEffect(() => {
    const screen = override ?? resolveScreenName(location.pathname);
    if (screen)
      trackScreenView(screen, { path: location.pathname, ...payload });
  }, [location.pathname, override, payload]);
}
